import {
    FETCH_WEBSITE_USER,
    FETCH_WEBSITE_CARDS_COUNT,
} from '../actions/types';

const initialState = {
    website_users: [],
    website_cards_count: 0,
};

const websiteReducer = (state = initialState, action) => {
    
    const { type, payload } = action;
    
    switch (type) {
        case FETCH_WEBSITE_USER:
            return {
                ...state,
                website_users: payload,
            };
        case FETCH_WEBSITE_CARDS_COUNT:
            return {
                ...state,
                website_cards_count: payload,
            };
        default:
            return state;
    }
};

export default websiteReducer;
